import { Navigate } from "react-router-dom"
import { useAuth } from "../auth/AuthProvider"

export default function AdminRoute({ children }){

 const { user, loading } = useAuth()

 if (loading) return null

 if(!["admin", "superadmin"].includes(user?.role)){
  return <Navigate to="/" />
 }

 return children
}
